import { signInWithPopup } from 'firebase/auth';
import { auth, googleProvider } from '@/lib/firebase';
import { useState } from 'react';

function BrandMark() {
  return (
    <span className="brand-mark" aria-hidden="true">
      <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4.5 6.5h13a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2Z" />
        <path d="M4.5 6.5V5a2 2 0 0 1 2-2h9.8" />
        <path d="M19.5 11h-4a2 2 0 0 0 0 4h4" />
        <path d="M16 13h.01" />
      </svg>
    </span>
  );
}

export default function LoginPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleGoogleLogin = async () => {
    setIsLoading(true);
    setError(null);

    try {
      await signInWithPopup(auth, googleProvider);
    } catch (err: any) {
      console.error('Login error:', err);
      setError(err.message || 'ログインに失敗しました');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-layout">
        <section className="auth-intro">
          <div className="brand-lockup">
            <BrandMark />
            <span>
              <span className="brand-name">シェア家計簿</span>
              <span className="brand-caption">家族のお金を、軽やかに</span>
            </span>
          </div>
          <p className="eyebrow">家族のための家計管理</p>
          <h1>お金の話を、<br />もっと軽やかに。</h1>
          <p>
            支出を記録して、予算を見て、必要なときに精算する。
            家族のお金の流れを、ひとつの場所で気持ちよく整えます。
          </p>
          <ul className="auth-benefits">
            <li>支出をかんたんに共有</li>
            <li>カテゴリごとの予算を見える化</li>
            <li>精算までスムーズに完了</li>
          </ul>
        </section>

        <section className="card auth-card">
          <p className="eyebrow">Welcome back</p>
          <h2>ログインして始める</h2>
          <p>家族の家計を、今日からすっきり管理しましょう。</p>

          {error && (
            <div className="mb-4 rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-600" role="alert">
              {error}
            </div>
          )}

          <button
            onClick={handleGoogleLogin}
            disabled={isLoading}
            className="btn btn-lg google-button w-full"
          >
            <svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
            {isLoading ? '処理中...' : 'Googleでログイン'}
          </button>

          <p className="mt-5 text-center text-xs leading-relaxed text-gray-400">
            ログインすることで、利用規約とプライバシーポリシーに同意したものとみなされます。
          </p>
        </section>
      </div>
    </div>
  );
}
